import { TonConnect, isWalletInfoCurrentlyInjected } from "@tonconnect/sdk";

export const connector = new TonConnect({
  manifestUrl: process.env.MANIFEST_URL || "/tonmanifest.json",
});

export async function tonPreconnect() {
  connector
    .getWallets()
    .then(async list => {
      const usingItem = list.find(item => {
        return isWalletInfoCurrentlyInjected(item);
      });
      console.log("Using list: ", usingItem);
      if (!usingItem) {
        alert("No TON wallet found");
        return;
      }
      const itm: any = usingItem;
      if (itm.jsBridgeKey) {
        connector.connect({
          jsBridgeKey: itm.jsBridgeKey,
        });
      } else {
        return;
      }
    })
    .catch(e => {
      console.log("Err: ", e);
    });
}

export async function theOpenNetworkAuth(
  onStatusChangeCallback?: (wallet: any) => void
): Promise<string | null | undefined> {
  return new Promise(async (resolve, reject) => {
    console.log("TON auth called");
    connector.getWallets().then(async list => {
      console.log("Wallet list: ", list);
      const usingItem = list.find(item => {
        return isWalletInfoCurrentlyInjected(item);
      });
      if (!usingItem) {
        console.log("No TON wallet found");
        resolve(null);
        return;
      }
      connector.onStatusChange(wallet => {
        console.log("Status changed");
        if (!wallet || !wallet.account) {
          console.log("No access to wallet");
          resolve(null);
          return;
        }
        if (onStatusChangeCallback) {
          connector.onStatusChange(onStatusChangeCallback);
        }
        resolve(wallet.account.publicKey);
      });
      const itm: any = usingItem;
      if (itm.jsBridgeKey) {
        connector.connect({
          jsBridgeKey: itm.jsBridgeKey,
        });
      } else {
        resolve(null);
      }
    });
    return;
  });
}
